export default {
  partners: []
}